<template>
  <div class="image-upload">
    <v-row no-gutters>
      <v-col cols="12">
        <cs-button
          id="btnUploadNewImage"
          primary
          label="Upload New Image"
          @click="selectFile()"
        ></cs-button>

        <label for="fileSelect">
          <input
            v-show="false"
            id="fileSelect"
            ref="fileSelect"
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            @change="setImage"
          />
        </label>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="mt-2 ml-2">
        <cropper
          v-show="imageSrc != ''"
          ref="cropper"
          class="image-upload-cropper"
          :src="imageSrc"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card v-show="cropImg != ''" class="crop-img">
          <v-img
            v-show="cropImg != ''"
            id="image-upload-crop-image"
            max-width="346px"
            max-height="100px"
            width="346px"
            height="100px"
            :src="cropImg"
          ></v-img>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <cs-button
          v-show="imageSrc != ''"
          id="btnCropImage"
          primary
          label="Crop Image"
          :disabled="disableCropButton"
          @click="cropImage"
        ></cs-button>
      </v-col>
    </v-row>
    <cs-form-dialog
      id="dlg-image-upload-notice"
      v-model="noticeDialogDisplayed"
      body-id="dlg-image-upload-notice-body"
      heading="Image Upload"
      :primary-action="{
        label: 'OK',
        eventName: 'primary-click'
      }"
      @primary-click="noticeDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        <div v-safe-html="noticeDialogMessage"></div>
      </template>
    </cs-form-dialog>
  </div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'ImageUpload',

  components: {
    Cropper
  },

  props: {
    imageUrl: { type: String, required: false, default: '' },
    disableCropButton: { type: Boolean, required: false, default: false },
    resetView: { type: Boolean, required: false, default: false }
  },

  emits: ['imageChanged'],

  data() {
    return {
      imageSrc: '',
      logoFile: '',
      cropImg: this.imageUrl || '',
      fileTypeAccept: `.png, .jpeg, .jpg`,
      fileMimeTypeAccept: [`image/png`, `image/jpeg`, `image/jpg`],
      noticeDialogDisplayed: false,
      noticeDialogMessage: ''
    };
  },

  watch: {
    imageUrl() {
      this.cropImg = this.imageUrl;
    },
    resetView(newVal) {
      if (newVal) {
        this.reset();
      }
    }
  },
  methods: {
    selectFile() {
      this.$refs.fileSelect.click();
    },

    setImage(e) {
      const file = e.target.files[0];
      const fileName = file.name;
      const fileExtension = fileName.split('.').pop();
      const fileType = file.type;
      this.logoFile = file;

      if (
        this.fileMimeTypeAccept.indexOf(fileType) < 0 ||
        !this.fileTypeAccept.includes(fileExtension)
      ) {
        this.alertCheckLogoFormat('Please select an image file.');
        e.target.value = '';
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imageSrc = event.target.result;
        };

        reader.readAsDataURL(file);
        this.$emit('imageChanged', file);
      } else {
        this.alertCheckLogoFormat('Sorry, FileReader API not supported.');
      }
    },

    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();

      this.cropImg = canvas.toDataURL();
      /*
      // TODO: Fix image cropping
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL(this.logoFile.type);
      */
      if (`${this.cropImg}` === '') return;

      this.getCroppedBlob();
    },

    getCroppedBlob() {
      const fileName = this.logoFile.name;
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob((blob) => {
        this.logoFile = new File([blob], fileName, { type: blob.type });
        this.$emit('imageChanged', this.logoFile);
      }, this.logoFile.type);
    },

    cropMove() {},

    alertCheckLogoFormat(errorMsg) {
      this.noticeDialogDisplayed = true;
      this.noticeDialogMessage = errorMsg;
    },

    reset() {
      this.imageSrc = '';
      this.logoFile = '';
      this.cropImg = '';
      this.cropImg = this.imageUrl;
      this.noticeDialogMessage = '';
      this.noticeDialogDisplayed = false;
    }
  }
};
</script>
<style scoped>
.image-upload {
  margin-bottom: 16px;
}

.image-upload-cropper {
  width: 100%;
  height: 250px;
}

.crop-img {
  width: 346px;
  height: 100px;
  margin-top: 8px;
  margin-left: 8px;
}
</style>
